import React from "react";

const Initiative: React.FC = () => {
  return (
    <div className="flex justify-center items-center w-full">
      <div className="flex flex-col w-full gap-5">
        <div className="grid md:grid-cols-3 gap-5 w-full">
          <div className="flex flex-col md:col-span-1">
            <h4 className="font-medium text-xl lg:text-2xl pt-4 xl:pt-6 xl:text-5xl">
              Our Initiatives
            </h4>
            <p className="text-sm sm:text-base pt-3 lg:text-lg xl:text-2xl lg:pt-5">
              Our skill development initiatives focus on providing opportunities
              for minority and underprivileged communities to achieve financial
              independence and professional growth.
            </p>
          </div>
          <div className="flex flex-col justify-between md:flex-row md:flex md:col-span-2 px-2 rounded-lg bg-white gap-2">
            <div className="flex flex-col px-5 py-4">
              <h4 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-6xl p-1 text-[#34368A]">
                01
              </h4>
              <p className="text-[#5C5C5C] lg:text-lg xl:text-[1.6rem] font-bold">
                Recognition of Prior Learning (RPL)
              </p>
              <div className="text-xs text-[#787878] font-light pt-4 lg:text-base xl:text-lg">
                <p>
                  We help individuals gain formal recognition for the skills
                  they already possess
                </p>
                <div className="flex gap-1 text-xs xl:text-base max-w-[30rem]">
                  <div>&#x2022;</div>
                  <p>
                    <span className="font-medium">Objective: </span> Assess and
                    certify prior learning to enhance employability.
                  </p>
                </div>
                <div className="flex gap-1 text-xs xl:text-base max-w-[25rem]">
                  <div>&#x2022;</div>
                  <p>
                    <span className="font-medium">Impact:</span>Boosts
                    confidence and opens doors to formal job opportunities.
                  </p>
                </div>
              </div>
            </div>
            <div className="h-full relative z-10 hidden xl:flex w-[37rem]">
              <img
                src="/skill/thumbs-up.png"
                className="w-full -mt-12 absolute bottom-0 -right-20"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-5 w-full">
          <div className="flex flex-col md:flex-row md:flex md:col-span-2 rounded-lg bg-white px-5 py-4 gap-2">
            <div className="flex flex-col flex-1 ">
              <h4 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-6xl p-1 text-[#34368A]">
                02
              </h4>
              <p className="text-[#5C5C5C] lg:text-lg xl:text-[1.6rem] font-bold py-1">
                Skill Development and Upskilling for Underprivileged Communities
              </p>
              <div className="text-xs text-[#787878] font-light pt-4 lg:text-base xl:text-lg">
                <p>
                  Empowering underserved sections of society through
                  comprehensive training programs.
                </p>
                <div className="flex gap-1 text-xs xl:text-base max-w-[30rem]">
                  <div>&#x2022;</div>
                  <p>
                    <span className="font-medium">Objective: </span> Provide
                    access to job-oriented and trade-specific training for
                    sustainable livelihoods.
                  </p>
                </div>
                <div className="flex gap-1 text-xs xl:text-base max-w-[25rem]">
                  <div>&#x2022;</div>
                  <p>
                    <span className="font-medium">Impact:</span> Enhances
                    employability and bridges the skill gap in various
                    industries.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center w-full">
            <div className="relative w-full">
              <img
                src="/skill/workplace.png"
                alt=""
                className="max-h-96 w-full md:w-full md:h-full"
              />
              <p className="absolute bottom-0 p-5 text-white font-light md:text-lg lg:text-xl xl:text-3xl">
                Managing Your Workforce, So You Can Focus on Growth
              </p>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-5 w-full">
          <div className="flex justify-center items-center h-full w-full order-2 md:order-1">
            <div className="relative w-full h-full">
              <img
                src="/skill/workplace.png"
                alt=""
                className="h-full w-full md:w-full md:h-full"
              />
              <p className="absolute bottom-0 p-5 text-white font-light md:text-lg lg:text-xl xl:text-3xl ">
                Managing Your Workforce, So You Can Focus on Growth
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:flex md:col-span-2 rounded-lg bg-white px-5 py-4 gap-2 order-1 md:order-2">
            <div className="flex flex-col flex-1">
              <h4 className="font-bold text-lg md:text-xl lg:text-2xl xl:text-6xl p-1 text-[#34368A]">
                03
              </h4>
              <p className="text-[#5C5C5C] lg:text-lg xl:text-[1.6rem] font-bold py-1">
                MNI (Marginalized and Niche Initiatives)
              </p>
              <div className="text-xs text-[#787878] font-light pt-4 lg:text-base xl:text-lg">
                <p>
                  Focused training programs for specialized sectors to uplift
                  marginalized groups.
                </p>
                <div className="flex gap-1 text-xs xl:text-base max-w-[30rem]">
                  <div>&#x2022;</div>
                  <p>Computer Training</p>
                </div>
                <div className="flex gap-1 text-xs xl:text-base max-w-[30rem]">
                  <div>&#x2022;</div>
                  <p>Culinary Arts</p>
                </div>
                <div className="flex gap-1 text-xs xl:text-base max-w-[30rem]">
                  <div>&#x2022;</div>
                  <p>Leather Craftsmanship</p>
                </div>
                <div className="flex gap-1 text-xs xl:text-base max-w-[30rem]">
                  <div>&#x2022;</div>
                  <p>Agriculture Practices</p>
                </div>
                <div className="flex gap-1 text-xs xl:text-base max-w-[30rem]">
                  <div>&#x2022;</div>
                  <p>Textile and Handloom Skills</p>
                </div>
                <div className="flex gap-1 text-xs xl:text-base max-w-[30rem]">
                  <div>&#x2022;</div>
                  <p>And more tailored to industry demands.</p>
                </div>
                <p className="pt-3 lg:pt-5">
                  And that's not all—we're extending our initiatives to many
                  more industries, ensuring no community or skill is left
                  behind. Together, we are creating opportunities and
                  transforming lives across sectors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Initiative;
